/**
 * AppShell - khung Telegram-style cho app routes (/chat, /tim-kiem Phase 1).
 * Nen gradient + 2 blob radial TINH (khong animate - compositor cache blur) +
 * NavRail desktop + BottomTabBar mobile + body flex cho route content.
 *
 * variant:
 *   - 'fixed' (default): shell cao 100% khung cha, overflow hidden - cho /chat
 *     (full-height app surface, thread scroll internal).
 *   - 'flow': shell gian theo content, page scroll binh thuong - cho /tim-kiem.
 *
 * Phase 1: prop children + variant. Props historyPane/docPanel them o Phase 2
 * (/tim-kiem master-detail). Spec muc 5.1.
 */
import type { ReactNode } from 'react';
import { useAuth } from '../../use-auth';
import { useLang } from '../../use-lang';
import { BottomTabBar } from './BottomTabBar';
import { NavRail } from './NavRail';
import '../../styles/app-shell.css';

export type AppShellProps = {
  children: ReactNode;
  variant?: 'fixed' | 'flow';
};

export function AppShell({ children, variant = 'fixed' }: AppShellProps) {
  const { lang } = useLang();
  const { isAuthenticated, profile, logout } = useAuth();
  const shared = {
    lang,
    isAuthed: isAuthenticated,
    userName: profile?.name ?? null,
    userEmail: profile?.email ?? null,
    onLogout: logout,
  } as const;
  return (
    <div
      className={
        variant === 'flow' ? 'asklaw-app-shell asklaw-app-shell--flow' : 'asklaw-app-shell'
      }
    >
      <NavRail {...shared} />
      <div className="asklaw-app-shell__body">{children}</div>
      <BottomTabBar {...shared} />
    </div>
  );
}
